import { Action } from 'redux'
import { IPaymentDictionary } from '../../models/PaymentDictionary'
import { PaymentDictionaryActions } from '../../reducers/paymentDictionary/actionNames'

export const requestPaymentDictionaries = (
  lastModifyDate?: Date,
): IRequestPaymentDictionaries => ({
  lastModifyDate,
  type: PaymentDictionaryActions.RequestPaymentDictionary,
})
export const paymentDictionariesAccepted = (
  dictionaries: IPaymentDictionary[],
): IPaymentDictionariesAccepted => ({
  dictionaries,
  type: PaymentDictionaryActions.PaymentDictionaryAccepted,
})
export const paymentDictionariesRejected = (
  errMessage: string,
): IPaymentDictionaryRejected => ({
  errMessage,
  type: PaymentDictionaryActions.PaymentDictionaryRejected,
})

export interface IRequestPaymentDictionaries
  extends Action<PaymentDictionaryActions.RequestPaymentDictionary> {
  lastModifyDate?: Date
}

export interface IPaymentDictionariesAccepted
  extends Action<PaymentDictionaryActions.PaymentDictionaryAccepted> {
  dictionaries: IPaymentDictionary[]
}

export interface IPaymentDictionaryRejected
  extends Action<PaymentDictionaryActions.PaymentDictionaryRejected> {
  errMessage: string
}
